import type { UserSearchResult } from "../queues";

/** The name persisted with a membership: display name, then given + surname, then identifiers. */
export function resolveUserDisplayName(user: UserSearchResult): string {
    const joined = [user.profile.givenName, user.profile.surname]
        .filter((p): p is string => typeof p === "string" && p.length > 0)
        .join(" ");
    return (
        user.profile.displayName ??
        (joined.length > 0 ? joined : null) ??
        user.profile.userPrincipalName ??
        user.profile.email ??
        user.id
    );
}